/* eslint-disable import/prefer-default-export */
export const RETENSION_DOWNLOAD_CALL_REPORT_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
